import React, { useState } from 'react'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Navigation from './components/Navigation'
import RestaurantManagement from './components/AdminDashboard'
import UserManagement from './components/UserManagement'
import ProfilePhotoReview from './components/ProfilePhotoReview'
import Signup from './components/Signup'

// Inner component that has access to auth context
const AppContent: React.FC = () => {
  const [currentPage, setCurrentPage] = useState('profile-photo-review')
  const [showSignup, setShowSignup] = useState(false)

  const renderPage = () => {
    if (showSignup) {
      return <Signup />
    }
    
    switch (currentPage) {
      case 'restaurant-management':
        return <RestaurantManagement />
      case 'user-management':
        return <UserManagement />
      case 'profile-photo-review':
        return <ProfilePhotoReview />
      default:
        return <ProfilePhotoReview />
    }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {showSignup ? (
        renderPage()
      ) : (
        <ProtectedRoute>
          <Navigation currentPage={currentPage} onPageChange={setCurrentPage} />
          <main className="pb-4 sm:pb-6">
            {renderPage()}
          </main>
        </ProtectedRoute>
      )}
      
    </div>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App
